import { CancelTokenSource } from 'axios';
import { BookmarkType, CreateBookmarkDTO, IBookmark, ShareBookmarkDTO } from '../types';
import { ApiRepository } from './main repository/api.repository';

export namespace BookmarkService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/bookmarks`;

  export const findAll = async ({
    cancelTokenSource,
    type,
  }: {
    cancelTokenSource: CancelTokenSource;
    type: BookmarkType;
  }): Promise<Array<IBookmark>> => {
    return ApiRepository.Core().get<Array<IBookmark>>(
      BASE_API,
      {
        type,
      },
      {
        cancelToken: cancelTokenSource.token,
      }
    );
  };

  export const createOne = async ({
    cancelTokenSource,
    createBookmarkDTO,
  }: {
    cancelTokenSource: CancelTokenSource;
    createBookmarkDTO: CreateBookmarkDTO;
  }) => {
    return ApiRepository.Core().post<CreateBookmarkDTO, IBookmark>(
      BASE_API,
      createBookmarkDTO,
      {},
      {
        cancelToken: cancelTokenSource.token,
      }
    );
  };

  export const deleteOne = async ({ id }: { id: number }): Promise<IBookmark> => {
    const ENDPOINT = `${BASE_API}/${id}`;
    return ApiRepository.Core().delete<IBookmark>(ENDPOINT);
  };

  export const sendSharingMail = async ({
    cancelTokenSource,
    shareBookmarkDTO,
  }: {
    cancelTokenSource: CancelTokenSource;
    shareBookmarkDTO: ShareBookmarkDTO;
  }) => {
    const ENDPOINT = `${BASE_API}/shares`;
    return ApiRepository.Core().post<ShareBookmarkDTO, IBookmark>(
      ENDPOINT,
      shareBookmarkDTO,
      {},
      { cancelToken: cancelTokenSource.token }
    );
  };
}
